function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import useBuildStyleWithTheme from "../../ThemeProvider/useBuildStyleWithTheme";
export var buildStyle = function(theme, param) {
    var end = param.end, readingDirection = param.readingDirection;
    var square = "calc(".concat(theme.spacing[5], " - (").concat(theme.size.border.base, "px * 2))");
    var errorFocusRing = "0 0 0 ".concat(theme.size.border.focus, "px ").concat(theme.borderColor.danger.focus);
    var focusRing = "0 0 0 ".concat(theme.size.border.focus, "px ").concat(theme.borderColor.interactive.focus);
    var _obj;
    var container = (_obj = {
        fontFamily: theme.font.base.family,
        lineHeight: theme.font.lineHeight.list,
        textIndent: 0,
        textShadow: 'none',
        display: 'flex',
        direction: readingDirection.direction,
        cursor: 'pointer',
        minHeight: theme.spacing[5],
        padding: "".concat(theme.spacing[3], " 0")
    }, _defineProperty(_obj, end.padding, theme.spacing[5]), _defineProperty(_obj, "alignItems", 'center'), _obj);
    var disabledContainer = {
        color: theme.font.color.disabled,
        cursor: 'not-allowed',
        '& > div': {
            cursor: 'not-allowed',
            backgroundColor: theme.backgroundColor.neutral.fill.disabled,
            borderColor: theme.borderColor.disabled
        }
    };
    var errorContainer = {
        borderColor: theme.borderColor.danger.base
    };
    var inputBase = {
        cursor: 'pointer',
        position: 'absolute',
        opacity: 0,
        margin: 0,
        '&:focus-visible + div': {
            boxShadow: focusRing,
            borderColor: theme.borderColor.interactive.base
        }
    };
    var inputError = {
        '&:focus-visible + div': {
            boxShadow: errorFocusRing,
            borderColor: theme.borderColor.danger.base
        }
    };
    var icon = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: square,
        height: square,
        fill: theme.font.color.fill,
        pointerEvents: 'none',
        '&:disabled': {
            fill: theme.font.color.disabled
        }
    };
    var _obj1;
    var checkboxStyle = (_obj1 = {
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'flex-start',
        justifyContent: 'center',
        borderRadius: theme.size.border.radius.twoX,
        height: square,
        flexShrink: 0,
        width: square,
        borderWidth: theme.size.border.base,
        borderStyle: 'solid',
        borderColor: theme.borderColor.base,
        backgroundColor: 'transparent'
    }, _defineProperty(_obj1, end.margin, 8), _defineProperty(_obj1, "position", 'relative'), _defineProperty(_obj1, "transitionDuration", theme.animation.duration[100]), _defineProperty(_obj1, "transitionProperty", 'border-color, box-shadow'), _defineProperty(_obj1, "transitionTimingFunction", theme.animation.productive.easeInOut.easing), _obj1);
    var checkedCheckboxStyle = {
        borderColor: theme.borderColor.interactive.base,
        backgroundColor: theme.backgroundColor.interactive.fill.base
    };
    var errorChecked = {
        borderColor: theme.borderColor.danger.base,
        backgroundColor: theme.backgroundColor.danger.fill.base
    };
    var indeterminateIcon = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: theme.spacing[5],
        height: theme.spacing[5],
        fill: theme.font.color.fill,
        '&:disabled': {
            fill: theme.font.color.disabled
        }
    };
    return {
        checkboxStyle: checkboxStyle,
        icon: icon,
        container: container,
        inputBase: inputBase,
        inputError: inputError,
        indeterminateIcon: indeterminateIcon,
        checkedCheckboxStyle: checkedCheckboxStyle,
        disabledContainer: disabledContainer,
        errorContainer: errorContainer,
        errorChecked: errorChecked
    };
};
export var useStyle = function(param) {
    var hasError = param.hasError, indeterminate = param.indeterminate, isRtl = param.isRtl, disabled = param.disabled, checked = param.checked;
    var ref;
    var ref1 = (ref = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    })) !== null && ref !== void 0 ? ref : {}, checkboxStyle = ref1.checkboxStyle, icon = ref1.icon, container = ref1.container, inputBase = ref1.inputBase, indeterminateIcon = ref1.indeterminateIcon, checkedCheckboxStyle = ref1.checkedCheckboxStyle, disabledContainer = ref1.disabledContainer, errorContainer = ref1.errorContainer, errorChecked = ref1.errorChecked, inputError = ref1.inputError;
    var errorStyle = checked || indeterminate ? _objectSpread({}, checkboxStyle, errorChecked) : _objectSpread({}, checkboxStyle, errorContainer);
    var nonErrorCheckbox = checked || indeterminate ? _objectSpread({}, checkboxStyle, checkedCheckboxStyle) : checkboxStyle;
    var checkboxContainer = hasError ? errorStyle : nonErrorCheckbox;
    var label = disabled ? _objectSpread({}, container, disabledContainer) : container;
    var input = hasError ? _objectSpread({}, inputBase, inputError) : inputBase;
    return {
        label: label,
        input: input,
        checkboxContainer: checkboxContainer,
        icon: icon,
        indeterminateIcon: indeterminateIcon
    };
};
